import Image from 'next/image';
import React from 'react'
import leftarrow from "../../assets/Image/comman/leftarrow.svg"
import rightarrow from "../../assets/Image/comman/rightarrow.svg"


interface headertype {
  header: string;
  subtitle: string
}
export const Title = ({ header, subtitle }: headertype) => {
  return (
    <div className='mt-16 lg:mt-24 mb-11 flex flex-col items-center' data-aos="zoom-in">
      <div className='flex justify-center gap-6' >
        <Image src={leftarrow} alt='left arrow' />
        <h6>{header}</h6>
        <Image src={rightarrow} alt='left arrow' />

      </div>
      <h2 className='font-bold max-w-[35rem] text-center pt-3' >{subtitle}</h2>
    </div>
  )
}
